import React from 'react';

const BS_ListGroups = () => {
    return (
        <div>
            <h1>BS_ListGroups Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_ListGroups;
